// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__11xV7","info":"PatientInfo_info__1s0k8"};